import React, { createContext, useState, useContext, Dispatch, SetStateAction } from "react";
import { ResponseFetchOrder } from "../types/types";

export interface GlobalStateInterface {
    eventSourceGlobal: EventSource | null;
    getOrderLoading: boolean;
    orderData: ResponseFetchOrder;
}

const GlobalStateContext = createContext({
    state: {} as Partial<GlobalStateInterface>,
    setState: {} as Dispatch<SetStateAction<Partial<GlobalStateInterface>>>,
});

const GlobalStateProvider = ({
    children,
    value = {} as GlobalStateInterface,
}: {
    children: React.ReactNode;
    value?: Partial<GlobalStateInterface>;
}) => {
    const [state, setState] = useState(value);
    return (
        <GlobalStateContext.Provider value={{ state, setState }}>
            {children}
        </GlobalStateContext.Provider>
    );
};

const useGlobalState = () => {
    const context = useContext(GlobalStateContext);
    if (!context) {
        throw new Error("useGlobalState must be used within a GlobalStateContext");
    }
    return context;
};

export { GlobalStateContext, GlobalStateProvider, useGlobalState };